import { useNavigate } from 'react-router-dom';

export function Landing() {
  const navigate = useNavigate();
  return (
    <div className="pt-8">
      <span className="gcm-eyebrow">Spring Challenge · Day 5</span>
      <h1 className="mt-3 mb-4">A month of posts, planned in 90 seconds.</h1>
      <p className="text-lg text-text-secondary mb-8 max-w-prose">
        Answer six questions about your business. We'll write a month of social content tuned to
        your audience, your platforms, and your voice.
      </p>

      <button
        type="button"
        className="gcm-btn gcm-btn-primary"
        onClick={() => navigate('/plan')}
      >
        Start planning
      </button>

      <div className="grid gap-4 sm:grid-cols-3 mt-12">
        <Step n="1" title="Tell us about the business" body="Six quick multiple-choice questions." />
        <Step n="2" title="See week 1" body="A tailored plan for the first week, on us." />
        <Step n="3" title="Unlock the full month" body="Drop your email for weeks 2 through 4." />
      </div>

      <p className="mt-12 text-sm text-text-secondary">
        Missed a day?{' '}
        <a
          href="https://springchallenge.goodcirclemarketing.com"
          className="text-gcm-gold font-semibold hover:underline"
        >
          See all challenges →
        </a>
      </p>
    </div>
  );
}

function Step({ n, title, body }: { n: string; title: string; body: string }) {
  return (
    <div className="gcm-card">
      <span className="gcm-eyebrow">Step {n}</span>
      <h4 className="mt-1 mb-1">{title}</h4>
      <p className="text-sm text-text-secondary">{body}</p>
    </div>
  );
}
